import React, { useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './NoDocumentsOverlay.module.scss';

type NoDocumentsOverlayProps = {
  onFileSelect: (files: File[]) => void;
};

const NoDocumentsOverlay: React.FC<NoDocumentsOverlayProps> = ({ onFileSelect }) => {
  const { t } = useTranslation('settings');
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files ?? []) as File[];
    if (files.length > 0) onFileSelect(files);
  };

  const handleBrowseClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '*';
    input.multiple = true;
    input.onchange = (e: any) => {
      const files = Array.from(e.target.files ?? []) as File[];
      if (files.length > 0) onFileSelect(files);
    };
    input.click();
  };

  return (
    <div
      className={`${styles.overlay} ${isDragging ? styles.dragActive : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleFileDrop}
    >
      <Stack spacing={2} alignItems='center'>
        <CloudUploadIcon sx={{ fontSize: 64, color: 'var(--app-text-default)' }} />
        <Typography variant='body2' sx={{ color: 'var(--app-text-default)' }}>
          {t('documentsCommon.dragAndDropToUploadFiles')}
        </Typography>
        <Typography variant='body2' sx={{ color: 'var(--app-text-muted)' }}>
          {t('documentsCommon.orUpper')}
        </Typography>
        <Button variant='contained' onClick={handleBrowseClick} sx={{ fontWeight: 'bold' }}>
          {t('documentsCommon.browseFiles')}
        </Button>
      </Stack>
    </div>
  );
};

export default NoDocumentsOverlay;
